import React from "react";
import DashboardGraphs from "@/Components/Dashboard/DashboardGraphs";
import { LoadingProvider } from "@/Contexts/LoadingContext";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import LayoutIcon from "@/Components/LayoutIcon";
import { Pie } from "@/Icons";
import AppLayout from "@/Layouts/AppLayout";
import DashboardFilter from "@/Pages/Emissions/Partials/DashboardFilter";
import QuestionsList from "@/Pages/Emissions/Partials/DashboardQuestionsList";
import { StickyContainer } from "@/Components/StickyContainer";

export default function Dashboard() {
  return (
    <LoadingProvider>
      <div className="mb-16 flex flex-col gap-8">
        {/* <a id="filter" className="h-0"></a> */}
        <StickyContainer triggerFromBottom={true} top="top-0 md:top-4 z-50" id="filter">
          <DashboardFilter />
        </StickyContainer>

        <h2 className="mt-4 border-t border-[#C4C4C4] pt-6 text-2xl font-bold">
          Total emissions
        </h2>

        <DashboardGraphs />

        <h2 className="mt-4 text-2xl font-bold">Your activities</h2>

        <QuestionsList />
      </div>
    </LoadingProvider>
  );
}

Dashboard.layout = (page) => (
  <AppLayout title="Results">
    <OrganizationLayout
      header="Results"
      icon={
        <LayoutIcon>
          <Pie size={40} className="text-black" />
        </LayoutIcon>
      }
      byline="Gain insights into your company's overall emissions and emissions per activity."
    >
      {page}
    </OrganizationLayout>
  </AppLayout>
);
